var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.$parent.mode == 'list' ? 'div' : 'tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.inPagination),expression:"inPagination"}],tag:"component",staticClass:"result"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }